import { Component, Input, OnInit } from '@angular/core';
import * as dayjs from 'dayjs';
import { Event } from '../../model/event';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})

export class EventComponent implements OnInit{
  @Input() event: Event;
  @Input() showEventAdminButton = false;
  userIsChair: boolean = false;

  // Convite de TPC pendente — usado pra mostrar a tarja no card em
  // "TPCs que participo". `userEvent` só chega em endpoints byUserRole.
  get hasPendingCommitteeInvite(): boolean {
    const ue: any = this.event?.userEvent;
    const role = String(ue?.role || '').toLowerCase();
    const answer = String(ue?.invitationAnswer || '').toLowerCase();
    return role === 'committee' && answer === 'not_answered';
  }

  constructor(
      public authService: AuthService
    ) {}

  ngOnInit(): void {
    this.checkIfEventChairOrAdmin();
    if(this.event.subEvents){
      this.sortEvents(this.event.subEvents);
    }
  }

  today() {
    return dayjs(new Date());
  }

  get baseUrl(): string {
    return window.location.origin;
  }

  public isEventPublic(event: Event): boolean {
    // `eventInfo` pode faltar em subEvents carregados via endpoints enxutos
    // (ex.: getSubconferencesByEvent no preview do event-settings) — nesse
    // caso trata como público em vez de crashear a expressão do template.
    const makePublicAt = event?.eventInfo?.makePublicAt;
    return !makePublicAt || this.today().isAfter(makePublicAt);
  }
  private checkIfEventChairOrAdmin(): void {
    this.authService.userIsAdminOrChair(this.event.id).subscribe(isAdminOrChair => {
      this.userIsChair = isAdminOrChair;
    });
  }
  public sortEvents(events: Event[]): void{
    events.sort((a,b) => a.formattedName < b.formattedName ? -1 : a.formattedName > b.formattedName ? 1 : 0);
  }
}
